import { IApiClient } from "../api-client";
import { EnvType } from "../services";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetItemsListResponse } from "../Types/get-items-list-response";
import { GetJobsResponse } from "../Types/get-jobs-response";
import { GetPlatformsNamesResponse } from "../Types/get-platform-names-response";
import { GetWorkflowUserTasksKpiResponse } from "../Types/get-workflow-user-tasks-kpi-response";
import { ListWorkflowInstanceResponse } from "../Types/list-workflow-instance-response";
import { WorkflowType } from "../Types/workflow-type";
import { MakeOperationRequest } from "../Types/make-operation-request";

export interface ICockpitApiClient {
  GetKpiWorkflowData(workflowType: WorkflowType, startDate: string, endDate: string): Promise<any>;
  GetOrdersList(): Promise<GetItemsListResponse>;
  GetIngestInstances(): Promise<ListWorkflowInstanceResponse>;
  ListJobs(): Promise<GetJobsResponse>;
  GetPlatforms(): Promise<GetPlatformsNamesResponse>;
  MakeAdminOperation(request: MakeOperationRequest): Promise<GenericResponseStd>;
  GetApiUrl(): string;
}

export default class CockpitApiClient implements ICockpitApiClient {
  readonly servicePort = 9527;
  readonly serviceBaseUrl = "cockpit-service/api";

  cockpitApiClient: IApiClient;

  constructor(dataApiClient: IApiClient, envType: EnvType) {
    this.cockpitApiClient = dataApiClient;
    if (envType === "local") this.cockpitApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  async GetKpiWorkflowData(
    workflowType: WorkflowType,
    startDate: string,
    endDate: string
  ): Promise<GetWorkflowUserTasksKpiResponse> {
    return await this.cockpitApiClient.get(
      `${this.serviceBaseUrl}/kpi/user-tasks/${workflowType}/${startDate}/${endDate}`
    );
  }

  async GetOrdersList(): Promise<GetItemsListResponse> {
    return await this.cockpitApiClient.get(`${this.serviceBaseUrl}/cockpit/orders`);
  }

  async GetIngestInstances(): Promise<ListWorkflowInstanceResponse> {
    return await this.cockpitApiClient.get(`${this.serviceBaseUrl}/cockpit/instances/ingest`);
  }

  async ListJobs(): Promise<GetJobsResponse> {
    return await this.cockpitApiClient.get(`${this.serviceBaseUrl}/cockpit/jobs`);
  }

  async GetPlatforms(): Promise<GetPlatformsNamesResponse> {
    return await this.cockpitApiClient.get(`${this.serviceBaseUrl}/cockpit/platforms`);
  }

  async MakeAdminOperation(request: MakeOperationRequest): Promise<GenericResponseStd> {
    return await this.cockpitApiClient.post(`${this.serviceBaseUrl}/cockpit/operation`, request);
  }

  //------Utils------
  GetApiUrl(): string {
    return this.cockpitApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
